import { AdvertisementAsset, FileResult } from '@horasys/bellplus/common/types';
import { FormHelperText } from '@mui/material';
import React from 'react';
import { convertToFileAssetFromAdvertisementAsset } from 'views/Common/typesUtils';
import UploadAsset from 'views/Common/UploadAsset';
import ContentLibraryModal from '../ContentLibraryModal';
import { useAppDispatch, useAppSelector } from 'Stores/Hooks/hooks';
import { AdvertisementState, delTemplateAssetDetails, handleAdvertisementAssetComplete } from 'Stores/Slices/advertisementSlice';
import { RootState } from 'Stores/store';
interface MultipleImageTemplateAssetUploadType {
	viewMode: boolean;
	advertisementAsset: AdvertisementAsset;
	errorObj: any;
}
export const MultipleImageTemplateAssetUpload = (
	props: MultipleImageTemplateAssetUploadType,
) => {
	const { advertisementAsset, viewMode, errorObj } = props;
	const advertisementStore: AdvertisementState = useAppSelector(
		(state: RootState) => state.advertisement,
	);
	const { mode } = advertisementStore;
	const dispatch = useAppDispatch();

	return (
		<>
			{advertisementAsset.children &&
				advertisementAsset.children.length &&
				advertisementAsset.children.map(
					(asset: AdvertisementAsset, index: number) => (
						<>
							<FormHelperText error>
								{errorObj && errorObj.children}
							</FormHelperText>
							<UploadAsset
								maxVideoTime={150}
								disabled={viewMode}
								reset={false}
								handleFileSelected={() => {
									return;
								}}
								uploadAssetType="advertisement"
								source={convertToFileAssetFromAdvertisementAsset(asset)}
								handleError={() => {
									return;
								}}
								handleDelete={() =>
									dispatch(delTemplateAssetDetails(asset, mode))
								}
								handleUploadComplete={(result) => {
									dispatch(
										handleAdvertisementAssetComplete(
											result,
											advertisementAsset,
											'multipleImages',
											index,
										),
									);
								}}
							/>
							{!asset.originalFileName && (
								<ContentLibraryModal
									mediaType="image"
									disabled={viewMode}
									handleUploadComplete={(result: FileResult) => {
										dispatch(
											handleAdvertisementAssetComplete(
												result,
												advertisementAsset,
												'multipleImages',
												index,
											),
										);
									}}
								/>
							)}
						</>
					),
				)}
		</>
	);
};
